import { useState } from "react";
import { toast } from "sonner";
import { AgentService } from "@/services/agent/agent.service";

export const useSandboxFile = () => {
  const [downloadingFiles, setDownloadingFiles] = useState<Set<string>>(new Set());
  const [deletingFile, setDeletingFile] = useState<string | null>(null);

  const downloadFile = async (filePath: string) => {
    // 既にダウンロード中ならスキップ
    if (downloadingFiles.has(filePath)) {
      return;
    }

    setDownloadingFiles((prev) => new Set(prev).add(filePath));
    try {
      await AgentService.downloadSandboxFile(filePath);
      toast.success(`${filePath} をダウンロードしました`);
    } catch (error) {
      console.error("Failed to download file:", error);
      toast.error("ダウンロードに失敗しました");
      throw error;
    } finally {
      setDownloadingFiles((prev) => {
        const next = new Set(prev);
        next.delete(filePath);
        return next;
      });
    }
  };

  const deleteFile = async (filePath: string, shouldConfirm: boolean = true) => {
    if (shouldConfirm && !confirm(`削除しますか?\n${filePath}`)) {
      return;
    }

    setDeletingFile(filePath);
    try {
      await AgentService.deleteSandboxFile(filePath);
      toast.success(`${filePath} を削除しました`);
    } catch (error) {
      console.error("Failed to delete file:", error);
      toast.error("削除できませんでした");
      throw error;
    } finally {
      setDeletingFile(null);
    }
  };

  const isDownloadingFile = (filePath: string) => {
    return downloadingFiles.has(filePath);
  };

  const isAnyFileDownloading = () => {
    return downloadingFiles.size > 0;
  };

  return {
    downloadFile,
    deleteFile,
    isDownloadingFile,
    isAnyFileDownloading,
    deletingFile,
  };
};
